import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";

import DashboardIcon from "@mui/icons-material/Dashboard";
import RouteIcon from '@mui/icons-material/Route';

import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import FormatListNumberedOutlinedIcon from "@mui/icons-material/FormatListNumberedOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import ArticleIcon from "@mui/icons-material/Article";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";

import { UserRole } from "../constants/userRoles.ts";


const roles = {
  system: [UserRole.SYSTEM_ADMIN],
  tenantAdmin: [UserRole.TENANT_ADMIN, UserRole.SYSTEM_ADMIN],
  tenantStaff: [UserRole.TENANT_STAFF],
};


export const navSections = [
  {
    key: "public",
    public: true,
    items: [
      { text: "Home", icon: <HomeOutlinedIcon />, path: "/", publicOnly: true },
      { text: "About", icon: <PersonOutlinedIcon />, path: "/about", publicOnly: true },
      { text: "Contact Us", icon: <PersonOutlinedIcon />, path: "/contact", publicOnly: true },
    ],
  },

  {
    key: "tenantStaff",
    title: "My Work",
    roles: [UserRole.TENANT_STAFF],
    items: [
      { text: "Dashboard", icon: <DashboardIcon />, path: "/staffDashboard" },
      { text: "My SOPs", icon: <ArticleIcon />, path: "/my-sops" },
      { text: "SOPs To Approve", icon: <ArticleIcon />, path: "/my-sop-approvals" },
      { text: "My Roles", icon: <PersonOutlinedIcon />, path: "/staffRoles" },
    ],
  },

  {
    key: "tenantAdmin",
    title: "Business Insight",
    roles: [UserRole.TENANT_ADMIN, UserRole.SYSTEM_ADMIN],
    items: [
      { text: "Current Business Risk", icon: <PersonOutlinedIcon />, path: "/operational-clarity-dashboard" },
      { text: "Operational Coverage", icon: <PersonOutlinedIcon />, path: "/clientAdminDashboard" },
      { text: "Knowledge Distribution", icon: <PersonOutlinedIcon />, path: "/knowledge-coverage-dashboard" },
    ],
  },
  {
    key: "tenantAdmin",
    title: "Business Management",
    roles: [UserRole.TENANT_ADMIN, UserRole.SYSTEM_ADMIN],
    items: [
      { text: "Role Allocation", icon: <PersonOutlinedIcon />, path: "/roleAllocation" },
      { text: "Staff Management", icon: <AccountTreeOutlinedIcon />, path: "/manageUsers" },
    ],
  },
  {
    key: "tenantAdmin",
    title: "SOP Management",
    roles: [UserRole.TENANT_ADMIN, UserRole.SYSTEM_ADMIN],
    items: [
      { text: "SOP Library", icon: <ArticleIcon />, path: "/sops/library" },
      { text: "SOP Approvals", icon: <ArticleIcon />, path: "/sop-approvals" },
      { text: "Rejected SOPs", icon: <ArticleIcon />, path: "/sops/rejected" },
    ],
  },
  {
    key: "systemAdmin",
    title: "System Admin",
    roles: [UserRole.SYSTEM_ADMIN],
    items: [
      { text: "Dashboard", icon: <DashboardIcon />, path: "/dashboard" },
      { text: "Kanban Board", icon: <ViewKanbanIcon />, path: "/kanban" },
      { text: "Calendar", icon: <RouteIcon />, path: "/calendar" },
      { text: "Tenants", icon: <PeopleAltOutlinedIcon />, path: "/manageTenants" },
      { text: "Contacts", icon: <PeopleAltOutlinedIcon />, path: "/manageContacts" },
      { text: "Companies", icon: <PeopleAltOutlinedIcon />, path: "/manageCompanies" },
      { text: "Audit Questions", icon: <PeopleAltOutlinedIcon />, path: "/manageAuditQuestions" },
      { text: "Operational Audits", icon: <PeopleAltOutlinedIcon />, path: "/manageOperationalAudits" },
      { text: "Interactions", icon: <FormatListNumberedOutlinedIcon />, path: "/manageInteractions" },
    ],
  },

  {
    key: "tenantConfig",
    title: "Tenant Configuration",
    roles: [UserRole.SYSTEM_ADMIN],
    items: [
      { text: "Playbooks", icon: <AccountTreeOutlinedIcon />, path: "/managePlaybooks" },
      { text: "Business Structure", icon: <AccountTreeOutlinedIcon />, path: "/manageBusinessStructure" },
      { text:  "Departments", icon: <AccountTreeOutlinedIcon />, path: "/manageDepartments" },
      { text: "Roles", icon: <AccountTreeOutlinedIcon />, path: "/manageTenantRoles" },
      { text: "Tasks", icon: <FormatListNumberedOutlinedIcon />, path: "/manageTasks" },
      { text: "Projects", icon: <AccountTreeOutlinedIcon />, path: "/manageProjects" },
      { text: "Manage SOPs", icon: <ArticleIcon />, path: "/manageSOPs" },
    ],
  },
];
